// extracted by mini-css-extract-plugin
module.exports = {"rows":"DeviceForm_rows__1oWqn","row":"DeviceForm_row__14OPE","buttonRow":"DeviceForm_buttonRow__3JI57","error":"DeviceForm_error__3RCP2"};